import React, { useState, useContext, useEffect } from "react";
import {
  useForm,
  Controller,
  FormContext,
  useFormContext,
} from "react-hook-form";
import { Grid, Box, Paper } from "@material-ui/core";
import useStyles from "../../../themes/makeStyles";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import PathsandTitle from "../../../constants/pathsAndTitle";
import MainHeading from "../../../components/MainHeading";
import { useHistory } from "react-router-dom";
import TextField from "../../../components/TextField";
import DateComponent from "../../../components/DateComponent";
import Button from "@material-ui/core/Button";
import clsx from "clsx";
import FormValidationErrorMessage from "../../../components/FormValidationErrorMessage";
import Autocomplete from "../../../components/AutoComplete";
import GlobalContext from "../../../common/contexts/GlobalContext";
import { default as CommonMethods } from "../../../common/commonMethods";
import Notifications from "../../../components/Notifications";
import LabelConstantsData from "../../../constants/LabelConstantsData";
import LobConstants from "../../../constants/LobConstants";
import { default as Apiservices } from "../../../common";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import SimpleBackdrop from "../../../components/Backdrop";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import * as XLSX from "xlsx/xlsx.mjs";
import { saveAs } from "file-saver";
import {
  Table,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from "@material-ui/core";
import moment from "moment";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(0),
  },
}));

const useStyles2 = makeStyles({
  table: {
    minWidth: "100%",
    whiteSpace: "nowrap",
    td: {},
  },
  toobarBgColor: {
    "& .MuiToolbar-regular": {
      background: "#fff",
    },
  },
  container: {
    maxHeight: "80vh",
    minHeight: "100px",
    overflowY: "hidden",
    "&:hover": {
      overflowY: "auto",
      "&::-webkit-scrollbar": {
        width: "4px",
      },

      /* Track */

      "&::-webkit-scrollbar-track": {
        background: "#fff",
      },

      /* Handle */

      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#d4d8da",
        borderRadius: "20px",
      },

      /* Handle on hover */

      "&::-webkit-scrollbar-thumb:hover": {
        background: "",
      },
    },
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

export default function RebateSummaryReport() {
  var classesTwo = useStyles();
  const classes = useStyles2();
  const history = useHistory();
  const methods = useForm();
  const {
    register,
    control,
    errors,
    handleSubmit,
    setValue,
    reset,
    getValues,
    validateform,
    triggerValidation,
  } = methods;

  const [notify, setNotify] = React.useState({
    isOpen: false,
    message: "",
    type: "",
    timing: "",
  });

  const [expandedPanel, setExpandedPanel] = React.useState({
    panel1: true,
    panel2: true,
    panel3: true,
    panel4: true,
  });

  const handleAccordionChange =
    (panel, expandedPanel) => (event, isExpanded) => {
      let expansionPanelList = {};
      expansionPanelList = expandedPanel;

      expansionPanelList[panel] = expansionPanelList[panel] ? false : true;
      setExpandedPanel({
        panel1:
          panel === "panel1"
            ? expansionPanelList[panel]
            : expansionPanelList["panel1"],
        panel2:
          panel === "panel2"
            ? expansionPanelList[panel]
            : expansionPanelList["panel2"],
        panel3:
          panel === "panel3"
            ? expansionPanelList[panel]
            : expansionPanelList["panel3"],
        panel4:
          panel === "panel4"
            ? expansionPanelList[panel]
            : expansionPanelList["panel4"],
      });
    };

  const [displayBackDrop, setDisplayBackDrop] = useState(false);
  const [keys, setKey] = useState([]);
  const [table_data, setTabledata] = useState([]);
  const [keys_value, setKeyvalue] = useState([]);
  const [rakename, setRakename] = useState([]);
  const [downloadData, setDownloadData] = useState();

  const handleToggle = () => {
    return true;
  };

  const handleClose = () => {
    return true;
  };

  useEffect(() => {
    const fetchData = async () => {
      let filter = null;
      setDisplayBackDrop(true);
      const listsResponse = await Apiservices.rebatesummaryreport(filter);
      console.log("listsResponse", listsResponse);
      let table_data = listsResponse.records;
      setDownloadData(table_data);
      let keys = Object.keys(table_data.length ? table_data[0] : {});
      let keys_value = Object.values(table_data.length ? table_data[0] : {});
      table_data.splice(0, 1);
      setKey(keys);
      setTabledata(table_data);
      setKeyvalue(keys_value);
      setDisplayBackDrop(false);
      let list = table_data.map((row) => {
        return row.rake;
      });
      setRakename(list);
    };
    fetchData();
  }, []);

  const HandleData = async () => {
    let filter = {
      rake: methods.getValues("rake"),
      from_date: methods.getValues("from_date")
        ? moment(methods.getValues("from_date")).format("YYYY-MM-DD")
        : methods.getValues("from_date"),
      to_date: methods.getValues("to_date")
        ? moment(methods.getValues("to_date")).format("YYYY-MM-DD")
        : methods.getValues("to_date"),
    };
    setDisplayBackDrop(true);
    const listsResponse = await Apiservices.rebatesummaryreport({
      filter: filter,
    });
    let table_data = listsResponse.records;
    setDownloadData(table_data);
    console.log("hello", table_data);
    let keys = Object.keys(table_data.length ? table_data[0] : {});
    let keys_value = Object.values(table_data.length ? table_data[0] : {});
    table_data.splice(0, 1);
    setKey(keys);
    setTabledata(table_data);
    setKeyvalue(keys_value);
    setDisplayBackDrop(false);
  };

  const ExcelDownload = async () => {
    if (!downloadData) {
      setNotify({
        isOpen: true,
        message: `No Data to export`,
        type: "warning",
        timing: 3000,
      });
    } else {
      setNotify({
        isOpen: true,
        message: `Downloading..`,
        type: "success",
        timing: 3000,
      });
      // Create a worksheet
      const worksheet = XLSX.utils.json_to_sheet(downloadData, {
        // This function transforms each cell
        cellDates: true, // If you have date fields in your downloadData
        cellNF: true, // Preserve number formats
        cellText: false, // Do not convert numbers to text
        header: Object.keys(downloadData[0]), // Ensure headers are taken from keys
      });

      // Create a workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // Write workbook to an Excel file
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      saveAs(blob, "Reabate Summary Report.xlsx");
    }
  };

  return (
    <div>
      <Box py={1}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <Grid item xs={12} sm>
            <Box py={2}>
              <h3 className={classes.secondHeading}>Rebate Summary Report</h3>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <FormContext {...methods}>
        <form Validate id="clearance">
          <React.Fragment>
            <Box py={1}>
              <Paper elevation={0}>
                <Box px={4} py={2}>
                  <Box pt={1}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6} md={6} lg={3}>
                        <Autocomplete
                          name={`rake`}
                          Values={rakename}
                          rules={{ required: true }}
                          error={methods.errors.rake}
                          label="Select Rake"
                        />
                        {methods.errors.rake && (
                          <FormValidationErrorMessage
                            errors={methods.errors}
                            errorMessagePrefix="Rake"
                            name="rake"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <DateComponent
                          label="Operating Year Start Date"
                          name={`from_date`}
                          // required={true}
                          disabled={false}
                          control={control}
                          error={errors.from_date}
                        // rules={{ required: true }}
                        />
                        {errors.from_date && (
                          <FormValidationErrorMessage
                            errors={methods.errors}
                            errorMessagePrefix="From Date"
                            name="from_date"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <DateComponent
                          label="Operating Year End Date"
                          name={`to_date`}
                          // required={true}
                          disabled={false}
                          control={control}
                          error={errors.to_date}
                        // rules={{
                        //   required: true,
                        // }}
                        />
                        {errors.to_date && (
                          <FormValidationErrorMessage
                            errors={methods.errors}
                            errorMessagePrefix="To Date"
                            name="to_date"
                          />
                        )}
                      </Grid>
                      <Grid item>
                        <Button
                          onClick={HandleData}
                          color="primary"
                          variant="contained"
                          className="btnMinWidthSearch"
                        >
                          Generate
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Paper>
            </Box>
            {table_data.length > 0 ? (
              <Box py={1}>
                <Paper elevation={0}>
                  <Accordion
                    expanded={expandedPanel["panel3"] === true}
                    onChange={handleAccordionChange("panel3", expandedPanel)}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel3a-content"
                      id="panel3a-header"
                    >
                      <Typography className={classes.secondHeading}>
                        Rebate Details
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Box width="100%">
                        <Grid container spacing={2} justify="flex-end">
                          <Grid item>
                            <Button
                              variant="contained"
                              color="primary"
                              className={clsx(classes.subTextButton)}
                              type="button"
                              startIcon={<CloudDownloadIcon />}
                              onClick={ExcelDownload}
                            >
                              Export to Excel
                            </Button>
                          </Grid>
                        </Grid>
                        <TableContainer
                          component={Paper}
                          className={clsx("freezeTable", classes.table)}
                        >
                          <Table
                            // className={classes.table}
                            aria-label="simple table"
                            stickyHeader
                          >
                            <TableHead>
                              <TableRow>
                                {keys_value.map((item) => (
                                  <StyledTableCell
                                    align="center"
                                    style={{ minWidth: 190 }}
                                  >
                                    <b>{item}</b>
                                  </StyledTableCell>
                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {table_data.map((item, idx) => (
                                <TableRow key={idx}>
                                  {keys.map((key, idx) => (
                                    <StyledTableCell
                                      align="center"
                                      style={{ minWidth: 120 }}
                                    >
                                      {item[key]}
                                    </StyledTableCell>
                                  ))}
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                </Paper>
              </Box>
            ) : (
                "No Data Found"
              )}
          </React.Fragment>
        </form>
        {displayBackDrop && (
          <SimpleBackdrop
            handleToggle={handleToggle}
            handleClose={handleClose}
          />
        )}
        <Notifications notify={notify} setNotify={setNotify} />
      </FormContext>
    </div>
  );
}
